import { FC, useEffect, useState } from "react";
import { fetchFile } from "../Service/restapi/fileShareService";
import { ActionIcon, Box, Center, Image, Skeleton, Text } from "@mantine/core";
import { openModal } from "@mantine/modals";

interface Props {
  entityId: string;
  entityType: string;
  fileName: string;
  fullWidth?: boolean;
  compact?: boolean;
}

const BookitupEntityPreview: FC<Props> = ({
  entityId,
  entityType,
  fileName,
  fullWidth = false,
  compact = false,
}) => {
  const [imageUrl, setImageUrl] = useState<string>();
  const [hovering, setHovering] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let objectUrl: string;
    setLoading(true);
    fetchFile(entityType, entityId, fileName)
      .then((res) => {
        if (res.ok) {
          res.blob().then((blob) => {
            objectUrl = URL.createObjectURL(blob);
            setImageUrl(objectUrl);
          });
        }
      })
      .finally(() => setLoading(false));
    // Clean up to prevent memory leaks
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [entityId, entityType, fileName]);

  const onClick = () =>
    openModal({
      size: "xl",
      title: (
        <Text weight="bolder" size="xl">
          {fileName}
        </Text>
      ),
      children: <Image src={imageUrl} />,
    });

  const previewWidth = fullWidth ? "100%" : compact ? 92 : 200;
  const previewHeight = fullWidth ? undefined : compact ? 64 : undefined;

  return (
    <Center sx={{ width: fullWidth ? "100%" : compact ? 92 : undefined }}>
      {loading && (
        <Skeleton
          visible
          width={previewWidth}
          height={fullWidth ? 240 : compact ? 64 : 180}
        />
      )}
      <Box
        pos="relative"
        mb={compact ? 0 : "md"}
        sx={{ width: fullWidth ? "100%" : compact ? 92 : undefined }}
      >
        {imageUrl && (
          <>
            <Image
              src={imageUrl}
              width={previewWidth}
              height={previewHeight}
              fit="contain"
              radius={compact ? 3 : fullWidth ? "sm" : 0}
              alt="Vorschau"
              onClick={onClick}
              sx={{ cursor: "pointer" }}
              onMouseEnter={() => setHovering(true)}
              onMouseLeave={() => setHovering(false)}
            />
            {hovering && (
              <ActionIcon pos="absolute" style={{ bottom: 10, right: 10 }}>
                🔎
              </ActionIcon>
            )}
          </>
        )}
      </Box>
    </Center>
  );
};

export default BookitupEntityPreview;
